import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import { PersonIdentifierViewModel } from '../../../models/Entities/Person/Identifier/PersonIdentifierModels';

// store
import * as PersonIdentifiersStore from '../../../redux/middleware/PersonIdentifiers.Middleware';

export interface IProps {
  PersonId: number;
  PersonType?: number | undefined;
}

interface ConnectedProps {
  isLoading: boolean | undefined;
  isLoadingSuccessfully: boolean | undefined;
  failOnLoading: boolean | undefined;
  isDeleting: boolean | undefined;
  failOnDeleting: boolean | undefined;
  error: ErrorType | undefined;
  identifiers: PersonIdentifierViewModel[];
}

interface DispatchProps {
  GetIdentifiersByPersonId: typeof PersonIdentifiersStore.actionCreators.GetIdentifiersByPersonId;
  DeletePersonIdentifier: typeof PersonIdentifiersStore.actionCreators.DeletePersonIdentifier;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isLoading: state.PersonIdentifiers?.isLoadingAll,
  isLoadingSuccessfully: state.PersonIdentifiers?.successLoadingAll,
  failOnLoading: state.PersonIdentifiers?.failOnLoadingAll,
  isDeleting: state.PersonIdentifiers?.isDeletingOne,
  failOnDeleting: state.PersonIdentifiers?.failOnDeletingOne,
  error: state.PersonIdentifiers?.error,
  identifiers: (state.PersonIdentifiers?.list ?? []).filter(
    (item: PersonIdentifierViewModel) => item.personId === ownProps.PersonId
  ),
  ...ownProps
});

export const mapDispatchToProps = {
  ...PersonIdentifiersStore.actionCreators
};
